import {Component, OnInit, ElementRef, Input, AfterViewInit} from '@angular/core';
import {CurrentRouteService} from '../currentRoute.service';
import {Router, ActivatedRoute} from '@angular/router';

import {HighlightLoader, HighlightAutoResult} from 'ngx-highlightjs';
import {AccountIdService, AgencyIdService} from "../account.service";

const themeGithub: string = 'node_modules/highlight.js/styles/github.css';
const themeAndroidStudio: string = 'node_modules/highlight.js/styles/androidstudio.css';

import {environment} from '../../environments/environment';

//import Prism from 'prismjs';

@Component({
  selector: 'app-tracker-tag',
  templateUrl: './tracker-tag.component.html',
  styleUrls: ['./tracker-tag.component.css']
})
export class TrackerTagComponent implements OnInit {

  helps: string[] = [
    "Copy and place tag for each page you want to track",
  ];

  agency_id: string;
  account_id: string;


  response: HighlightAutoResult;
  code: string;

  start_date: string = "2022-07-01";
  end_date: string = "2022-07-30";
  network: string = "facebook";

  code_angle = "angle_ad_id={{ad.id}}"


  currentTheme: string = themeGithub;

  constructor(public router: Router,
              private route: ActivatedRoute,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private currentrouteService: CurrentRouteService,
              private hljsLoader: HighlightLoader) {}

  ngAfterViewInit() {

    // const code = (this.code || this.el.nativeElement.innerText)
    // const grammar = Prism.languages[this.language];
    // const html = Prism.highlight(code, grammar, this.language);
    // this.el.nativeElement.innerHTML = html;
  }

  onHighlight(e: HighlightAutoResult) {
    console.log(e);
    this.response = {
      language: e.language,
      relevance: e.relevance,
      secondBest: '{...}',
      value: '{...}',
    };
  }


  ngOnInit(): void {
    this.currentrouteService.announceCurrentRoute(this.router.url);

    this.route.params.subscribe(parms => {
        this.agency_id = parms['agency_id'],
        this.account_id = parms['account_id']
        this.agencyidService.announceAgencyId(this.agency_id);
        this.accountidService.announceAccountId(this.account_id);
        this.formatTag(this.account_id)
    });
  } //end ngOnInit


  formatTag(account_id) {

    /*
    TODO place the tracker domains in the environment
    */

    let tracker_domain = "";
    if (environment['environment'] != 'production') {
      tracker_domain = "https://tracker.devangleattribution.com";
    } else {
      tracker_domain = "https://tracker.angleattribution.com";
    }

    this.code = `
      <script>
          var api_key_script = document.createElement("script");
          api_key_script.innerHTML="var api_key='${account_id}'";
          var doc_head = document.head;
          var test_script=document.createElement("script");
          test_script.type = "text/javascript";
          test_script.src= "${tracker_domain}";
          doc_head.appendChild(api_key_script);
          doc_head.appendChild(test_script);
      </script>
    `;
    // this.hljsLoader.setTheme(this.currentTheme);
  } //end formatTag

  changeTheme() {
    this.currentTheme = this.currentTheme === themeGithub ? themeAndroidStudio : themeGithub;
    this.hljsLoader.setTheme(this.currentTheme);
  }

  selectCagadValue(value) {
    console.log(value);
  }

  network_id: string = null;
  network_name: string = null;
  selectValueNetwork(value) {
    this.network_id = value['network_id'];
    this.network_name = value['network_name'];
    console.log('network_id from parent:',this.network_id, this.network_name)
  }

  campaign_id: string = null;
  selectCagadValueCampaign(value){
    this.campaign_id = value;
    console.log('campaign_id from parent:',this.campaign_id)
  }

  adgroup_id: string = null;
  selectCagadValueAdgroup(value){
    this.adgroup_id = value;
    console.log('adgroup from parent:',this.adgroup_id)
  }

  ad_id: string = null;
  selectCagadValueAd(value){
    this.ad_id = value;
    console.log('ad from parent:',this.ad_id)
  }


} //end component
